const mutations = {
  mutationCommissions(state, payload) {
    state.commissions = payload.data;
    state.commissionUserIds = payload.meta?.ids ?? [];
  },

  mutationCommission(state, payload) {
    state.commission = payload.data;
    state.commissionMeta = payload.meta;
    state.commissionAll.header = payload.data.header; // assign for lazy loading

    payload.data.items.forEach((item) => {
      state.commissionAll.items.push(item);
    });
  },

  mutationCommissionValues(state, payload) {
    state.commissionValues = payload;
  },

  mutationCommissionSelf(state, payload) {
    state.self = payload;
  },

  mutationResetCommissionAll(state) {
    state.commissionAll.items = [];
  },

  mutationCommissionDetail(state, payload) {
    state.commissionDetail = payload;
  },

  mutationCommissionMeta(state, payload) {
    state.commissionDetailMeta = payload;
  },

  mutationCommissionDetailQuickView(state, payload) {
    state.commissionDetailQuickView = payload;
  },
};

export default mutations;
